import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState } from 'react'
import { Wrapper } from './styles'

type Option = { value: string | boolean; label: string; description?: string }

type Props = {
  initialValue?: string
  value?: string | boolean
  values: Option[]
  withIcon?: boolean
  onChange: (newValue: string | boolean) => void
}

export default function IosToggle(props: Props) {
  const { values, onChange } = props
  const [localValue, setLocalValue] = useState<string | boolean>(props.initialValue || props.value || props.values[0].value)

  const selectedValue = props.value || localValue

  const selectOption = (newValue: string | boolean) => {
    if (newValue === selectedValue) {
      return
    }
    setLocalValue(newValue)
    onChange?.(newValue)
  }

  const activeIndex = values.findIndex(x => x.value === selectedValue)
  const optionCount = values.length
  const indicatorWidth = `calc(${100 / optionCount}% - 2px)`
  const hasDescriptions = values.some(x => x.description)

  return (
    <Wrapper className={`ios-toggle ${hasDescriptions ? 'with-descriptions' : ''}`} data-option-count={optionCount}>
      <div
        className="active-indicator"
        style={{
          width: indicatorWidth,
          transform: `translateX(calc(${100 * activeIndex}% + ${activeIndex * 2}px))`,
        }}
      />

      {values.map(x => (
        <div
          key={x.value + ''}
          className={'option' + (selectedValue === x.value ? ' active' : '')}
          onClick={() => selectOption(x.value)}
        >
          {props.withIcon && <FontAwesomeIcon icon={faCheckCircle} />}
          <span className="label">{x.label}</span>
          {x.description && <span className="description">{x.description}</span>}
        </div>
      ))}
    </Wrapper>
  )
}
